export default "__VITE_ASSET__CBFkjzGI__"